const getRoundData = state => state?.ats?.roundData
const getPreviewData = state => state?.ats?.previewData

const updatedRoundData = state => state?.ats?.updateRoundData
const getJobRolePreview = state => state?.ats?.getJobRolePreview
const selectors = {
  getRoundData,
  updatedRoundData,
  getPreviewData,
  getJobRolePreview,
}

export default selectors
